export default "__VITE_ASSET__DuRWM$bf__"